module.exports = __webpack_public_path__ + "img/main.4fd26ed3.png";